<template>
    <div class="session__list_table">
        <component-table
            :labels="[
                {
                    key: 'fromDate',
                    title: 'Date',
                    type: 'date',
                    sortable: true
                },
                {
                    key: 'rooms',
                    title: 'Locations',
                    type: 'array',
                    subKey: ['venueName', 'name'],
                    sortable: true
                },
                {
                    key: 'trainers',
                    title: 'Trainers',
                    type: 'array',
                    subKey: 'name',
                    sortable: true
                },
                {
                    key: 'spaces',
                    title: 'Spaces',
                    type: 'object',
                    subKey: 'available',
                    subType: 'number',
                    sortable: true
                },
                {
                    key: 'status',
                    title: 'Status',
                    type: 'string',
                    sortable: true
                },
                {
                    key: 'actions',
                    title: '',
                    type: '',
                    sortable: false
                }
            ]"
            :items="items"
            :component-table-item="SessionListTableItem"
        />
    </div>
</template>

<script>
import SessionListTableItem from '@/components/ebs/sessions/list/SessionListTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'

export default {
  components: {
    ComponentTable
  },
  name: 'session-list-table',
  data () {
    return {
      SessionListTableItem
    }
  },
  props: {
    items: {
      type: [Array, Object]
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionlisttable";
</style>
